// extracted by mini-css-extract-plugin
export default {"dropdownBox":"style_dropdownBox__WX4Xs","box":"style_box__Vso9u","active":"style_active__X3U6s","title":"style_title__QjQ+t","item":"style_item__jmEx3"};